/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ baseName: NonNullable<unknown> }} Topical_Silly_Mongoose_RadiateInputs */

const en_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Refresh ${i?.baseName}`)
};

const id_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Segarkan ${i?.baseName}`)
};

const ms_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Muat semula halaman ${i?.baseName}`)
};

const ca_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualitzar ${i?.baseName}`)
};

const cs_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obnovit ${i?.baseName}`)
};

const da_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opdater ${i?.baseName}`)
};

const de_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} aktualisieren`)
};

const et_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Värskenda ${i?.baseName}`)
};

const es_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualizar ${i?.baseName}`)
};

const fr_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualiser ${i?.baseName}`)
};

const hr_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Osvježi ${i?.baseName}`)
};

const it_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rinnova ${i?.baseName}`)
};

const lv_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atsvaidzināt ${i?.baseName}`)
};

const lt_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atnaujinti ${i?.baseName}`)
};

const hu_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frissítés ${i?.baseName}`)
};

const nl_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} vernieuwen`)
};

const nb_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oppdater ${i?.baseName}`)
};

const pl_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odśwież ${i?.baseName}`)
};

const pt_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atualizar ${i?.baseName}`)
};

const ro_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reîmprospătează ${i?.baseName}`)
};

const sk_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obnoviť ${i?.baseName}`)
};

const sl_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Osvežite »${i?.baseName}«`)
};

const fi_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Päivitä ${i?.baseName}`)
};

const sv_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uppdatera ${i?.baseName}`)
};

const vi_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Làm mới ${i?.baseName}`)
};

const tr_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yenile: ${i?.baseName}`)
};

const el_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ανανέωση ${i?.baseName}`)
};

const bg_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Презареждане на ${i?.baseName}`)
};

const ru_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обновить ${i?.baseName}`)
};

const sr_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Освежи ${i?.baseName}`)
};

const uk_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Оновити ${i?.baseName}`)
};

const ka_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`განახლება ${i?.baseName}`)
};

const hi_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} रिफ्रेश करें`)
};

const th_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รีเฟรช ${i?.baseName}`)
};

const ko_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} 새로 고침`)
};

const zh_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`刷新 ${i?.baseName}`)
};

const zh_tw_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`刷新 ${i?.baseName}`)
};

const ja_topical_silly_mongoose_radiate = /** @type {(inputs: Topical_Silly_Mongoose_RadiateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} を更新`)
};

/**
* | output |
* | --- |
* | "Refresh {baseName}" |
*
* @param {Topical_Silly_Mongoose_RadiateInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const topical_silly_mongoose_radiate = /** @type {((inputs: Topical_Silly_Mongoose_RadiateInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Topical_Silly_Mongoose_RadiateInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_topical_silly_mongoose_radiate(inputs)
	if (locale === "ms") return ms_topical_silly_mongoose_radiate(inputs)
	if (locale === "ca") return ca_topical_silly_mongoose_radiate(inputs)
	if (locale === "cs") return cs_topical_silly_mongoose_radiate(inputs)
	if (locale === "da") return da_topical_silly_mongoose_radiate(inputs)
	if (locale === "de") return de_topical_silly_mongoose_radiate(inputs)
	if (locale === "et") return et_topical_silly_mongoose_radiate(inputs)
	if (locale === "es") return es_topical_silly_mongoose_radiate(inputs)
	if (locale === "fr") return fr_topical_silly_mongoose_radiate(inputs)
	if (locale === "hr") return hr_topical_silly_mongoose_radiate(inputs)
	if (locale === "it") return it_topical_silly_mongoose_radiate(inputs)
	if (locale === "lv") return lv_topical_silly_mongoose_radiate(inputs)
	if (locale === "lt") return lt_topical_silly_mongoose_radiate(inputs)
	if (locale === "hu") return hu_topical_silly_mongoose_radiate(inputs)
	if (locale === "nl") return nl_topical_silly_mongoose_radiate(inputs)
	if (locale === "nb") return nb_topical_silly_mongoose_radiate(inputs)
	if (locale === "pl") return pl_topical_silly_mongoose_radiate(inputs)
	if (locale === "pt") return pt_topical_silly_mongoose_radiate(inputs)
	if (locale === "ro") return ro_topical_silly_mongoose_radiate(inputs)
	if (locale === "sk") return sk_topical_silly_mongoose_radiate(inputs)
	if (locale === "sl") return sl_topical_silly_mongoose_radiate(inputs)
	if (locale === "fi") return fi_topical_silly_mongoose_radiate(inputs)
	if (locale === "sv") return sv_topical_silly_mongoose_radiate(inputs)
	if (locale === "vi") return vi_topical_silly_mongoose_radiate(inputs)
	if (locale === "tr") return tr_topical_silly_mongoose_radiate(inputs)
	if (locale === "el") return el_topical_silly_mongoose_radiate(inputs)
	if (locale === "bg") return bg_topical_silly_mongoose_radiate(inputs)
	if (locale === "ru") return ru_topical_silly_mongoose_radiate(inputs)
	if (locale === "sr") return sr_topical_silly_mongoose_radiate(inputs)
	if (locale === "uk") return uk_topical_silly_mongoose_radiate(inputs)
	if (locale === "ka") return ka_topical_silly_mongoose_radiate(inputs)
	if (locale === "hi") return hi_topical_silly_mongoose_radiate(inputs)
	if (locale === "th") return th_topical_silly_mongoose_radiate(inputs)
	if (locale === "ko") return ko_topical_silly_mongoose_radiate(inputs)
	if (locale === "zh") return zh_topical_silly_mongoose_radiate(inputs)
	if (locale === "zh-tw") return zh_tw_topical_silly_mongoose_radiate(inputs)
	if (locale === "ja") return ja_topical_silly_mongoose_radiate(inputs)
	return en_topical_silly_mongoose_radiate(inputs)
});